import { render, staticRenderFns } from "./ProcessPayments.vue?vue&type=template&id=d6b06610"
import script from "./ProcessPayments.vue?vue&type=script&lang=js"
export * from "./ProcessPayments.vue?vue&type=script&lang=js"
import style0 from "./ProcessPayments.vue?vue&type=style&index=0&id=d6b06610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports